<template>
  <div>
    <BannerSlider :itemsLength="items.length">
      <template v-slot:content="{ currentIndex }">
        <BannerSliderItem
          v-for="(item, index) in items"
          :key="index"
          v-show="currentIndex === index"
          :item="item"
        >
          <span
            class="slide-btn"
            :style="{ color: item.countDownTextColor }"
            @click="handleBannerClickButton(index)"
            >{{ item.bannerButtonText }}</span
          >
          <img
            class="bannerSlider_image"
            :style="{ height: imageHeight }"
            :src="item.imageUrl"
          />
          <h2 class="bannerSlider_title" v-html="item.title" />
          <p
            class="bannerSlider_description"
            :class="{
              bannerSlider_description_noButton: !item.buttonText,
            }"
            v-html="item.description"
          />
          <button
            v-if="item.buttonText"
            @click="handleBannerClickButton"
            v-html="item.buttonText"
            type="button"
            class="bannerSlider_button"
          />
        </BannerSliderItem>
      </template>
    </BannerSlider>
  </div>
</template>

<script>
import { BannerSlider, BannerSliderItem } from '@n11/so-ui-components';

export default {
  name: 'CampaignSlider',
  props: {
    items: {
      type: Array,
      required: true,
    },
    countDown: {
      type: Boolean,
      default: false,
    },
    imageHeight: {
      type: String,
    },
  },

  components: {
    BannerSlider,
    BannerSliderItem,
  },

  methods: {
    handleBannerClickButton(index) {
      window.location = this.items[index].url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.bannerSlider {
  margin: 0 0 8px 0;
  position: relative;
  width: 100%;
  height: 190px;
  overflow: hidden;
  font-family: 'Open Sans', sans-serif !important;

  &_image {
    border-radius: 8px;
    width: 100%;
    height: 190px;
    object-fit: cover;
  }

  &_title {
    width: 250px;
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: normal;
    color: $colorN00;
    position: absolute;
    bottom: 32px;
    left: 12px;
    text-shadow: 1px 1px black;
    float: right;
  }

  &_description {
    width: 175px;
    font-size: 11px;
    font-stretch: normal;
    font-style: normal;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: normal;
    color: $colorN00;
    position: absolute;
    bottom: 10px;
    left: 12px;
    text-shadow: 1px 1px black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &_noButton {
      width: 250px;
    }
  }

  &_button {
    width: 85px;
    border-radius: 6px;
    background-color: $blue-9;
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.09px;
    text-align: center;
    color: $colorN00;
    position: absolute;
    bottom: 7px;
    right: 12px;
    float: right;
    border: none;
    padding: 5px;
  }

  &_button:active {
    transform: translateY(1px);
  }

  &_button:focus {
    outline: none;
  }
}

.slide-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 100%);
  cursor: pointer;
}
</style>
